/**
 * Единый маппинг код статуса документа → цвет MUI (success, error, warning, info, primary, default).
 * Используется в DocumentStatusesContext и RepairsContext (подмножество REPAIR_*).
 */

const EXPLICIT_COLOR_MAP = {
  // Синие — новые, в процессе
  DRAFT: 'primary',
  NEW: 'primary',
  IN_PROGRESS: 'primary',
  REPAIR_SERVICE_CENTER: 'primary',
  REPAIR_REPAIR_WORK: 'primary',
  CUSTOMER_ORDER_NEW: 'primary',
  CUSTOMER_ORDER_PROCESSING: 'primary',

  // Зелёные — завершённые, успешные
  COMPLETED: 'success',
  REPAIR_CLOSED: 'success',
  REPAIR_ISSUED_TO_CLIENT: 'success',
  CUSTOMER_ORDER_COMPLETED: 'success',
  SALE_PAID: 'success',
  SALE_SHIPPED: 'success',
  RETURN_ACCEPTED: 'success',
  REPAIR_APPROVED: 'success',
  REPAIR_REPAIR_APPROVED: 'success',
  ORDER_DELIVERED: 'success',

  // Оранжевые — ожидание
  PENDING_APPROVAL: 'warning',
  REPAIR_UNDER_APPROVAL: 'warning',
  REPAIR_SPARE_WAITING: 'warning',
  REPAIR_WAITING_MATERIALS: 'warning',
  REPAIR_WAIT: 'warning',
  CUSTOMER_ORDER_WAITING_PAYMENT: 'warning',
  SALE_WAITING_PAYMENT: 'warning',
  SALE_PARTIALLY_PAID: 'warning',
  COMING_WAITING_DELIVERY: 'warning',
  COMING_PARTIALLY_RECEIVED: 'warning',
  ORDER_WAITING_ASSEMBLY: 'warning',

  // Красные — отменённые, отклонённые
  CANCELLED: 'error',
  REPAIR_DELETED: 'error',
  REPAIR_REJECTED: 'error',
  REPAIR_ORDER_CANCELLED: 'error',
  CUSTOMER_ORDER_CANCELLED: 'error',
  ORDER_CANCELLED: 'error',
  RETURN_REJECTED: 'error',

  // Серые — информационные
  COMING_DRAFT: 'default',
  COMING_ORDERED: 'info',
  COMING_CONFIRMED: 'info',
  COMING_RECEIVED: 'info',
  ORDER_ASSEMBLING: 'info',
  ORDER_DELIVERING: 'info',
  CUSTOMER_ORDER_WAITING_ASSEMBLY: 'info',
  CUSTOMER_ORDER_ASSEMBLING: 'info',
  CUSTOMER_ORDER_SHIPPING: 'info',
  CUSTOMER_ORDER_DELIVERING: 'info',
  CUSTOMER_ORDER_INVOICED: 'info',
  RETURN_UNDER_INSPECTION: 'info',
  REPAIR_MATERIALS_RECEIVED: 'info',
  REPAIR_SPARES_IN_STOCK: 'info',
};

/**
 * Возвращает цвет MUI для кода статуса документа.
 * Сначала проверяется явный маппинг, затем правила по подстрокам кода.
 *
 * @param {string} [statusCode] — код статуса (например REPAIR_CLOSED, ORDER_DELIVERED)
 * @returns {'success'|'error'|'warning'|'info'|'primary'|'default'}
 */
export function getDocumentStatusColor(statusCode) {
  if (!statusCode) return 'default';

  if (EXPLICIT_COLOR_MAP[statusCode]) {
    return EXPLICIT_COLOR_MAP[statusCode];
  }

  // Успешные статусы
  if (
    statusCode.includes('COMPLETED') ||
    statusCode.includes('DELIVERED') ||
    statusCode.includes('PAID') ||
    statusCode.includes('ACCEPTED') ||
    statusCode.includes('ISSUED_TO_CLIENT')
  ) {
    return 'success';
  }

  // Ошибки и отмены
  if (
    statusCode.includes('CANCELLED') ||
    statusCode.includes('REJECTED') ||
    statusCode.includes('ERROR') ||
    statusCode.includes('DELETED')
  ) {
    return 'error';
  }

  // Ожидание
  if (
    statusCode.includes('WAITING') ||
    statusCode.includes('PENDING') ||
    statusCode.includes('UNDER') ||
    statusCode.includes('WAIT')
  ) {
    return 'warning';
  }

  // В процессе
  if (
    statusCode.includes('PROGRESS') ||
    statusCode.includes('ASSEMBLING') ||
    statusCode.includes('SHIPPING') ||
    statusCode.includes('PROCESSING') ||
    statusCode.includes('DELIVERING')
  ) {
    return 'info';
  }

  // Черновик
  if (statusCode.includes('DRAFT') || statusCode.includes('NEW')) {
    return 'default';
  }

  return 'primary';
}
